module.exports = __webpack_public_path__ + "media/images/question-e21f166bd7431e0bcea4c7e3e0b16b1d.svg";